export class Trptvcharges {
    public VTCHARGEID!: number;
    public ACC_CODE!: string;
    public VEH_TYPE!: string;
    public F_CITY!: number;
    public T_CITY!: number;
    public F_LOC!: number;
    public T_LOC!: number;
    public FRT!: number;
    public ST_CRG!: number;
    public CLC_CRG!: number;
    public DD_CRG!: number;
    public OTR_CRG!: number;
    public SRV_CRG!: number;
    public CN_SPLVEHCHG!: number;
    public OTH_PARTY!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string; //  Date;
    //  Date;
    public UPDATED_DATE!: string; //  Date;
    //  Date;
    public IS_ACTIVE!: boolean;
}